import { RadioTab, Section, TabStrip } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { WizardButtons } from '../../00-builder/wizard-buttons'
import { actions as rawExistingNoteActions } from '../existing-note/existing-note-slice'
import { ExistingNotes } from '../existing-note/main/main'
import { NewNote } from '../new-note'
import { actions as rawNewNoteActions } from '../new-note/new-note-slice'
import { actions as rawNoteActions } from './note-step-slice'
import { SingleColumnView } from './primitives'

export const NoteStep = () => {
  const noteActions = useActions(rawNoteActions)
  const newNoteActions = useActions(rawNewNoteActions)
  const existingNoteActions = useActions(rawExistingNoteActions)
  const state = useAppSelector(state => state.note)
  const existingNoteState = useAppSelector(state => state.existingNote)

  return (
    <SingleColumnView>
      <Section type="primary">
        <TabStrip>
          <RadioTab
            data-testid="existing-note-tab"
            isSelected={state.noteType === 'existing'}
            onClick={() => noteActions.chooseExistingNote()}
          >
            Existing note
          </RadioTab>
          <RadioTab
            data-testid="new-note-tab"
            isSelected={state.noteType === 'new'}
            onClick={() => noteActions.chooseNewNote()}
          >
            New note
          </RadioTab>
        </TabStrip>
        {state.noteType === 'new' && <NewNote />}
        {state.noteType === 'existing' && <ExistingNotes />}
      </Section>

      {state.noteType === 'new' && (
        <WizardButtons
          canMoveNext
          canMoveBack={false}
          onMoveNext={() => newNoteActions.requestMoveNext()}
        />
      )}

      {state.noteType === 'existing' && (
        <WizardButtons
          canMoveBack={false}
          canMoveNext={existingNoteState.canProceed}
          onMoveNext={() => existingNoteActions.moveNext()}
        />
      )}
    </SingleColumnView>
  )
}
